import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import io from "socket.io-client";
import PanelLayout from "./PanelLayout";
import getRoutes from "src/app/routes";
import NotFound from "src/containers/Error/NotFound";
import { SockectProvider } from "@components/SocketProvider";
import jwt_decode from "jwt-decode";

let socket = null;

// if (process.env.NODE_ENV !== "production")
socket = io(process.env.REACT_APP_SOCKET_URL, {
  secure: true,
  auth: {
    token: localStorage.getItem("plano-jwt"),
  },
});

export default function Panel() {
  const [token, setToken] = useState(
    jwt_decode(localStorage.getItem("plano-jwt"))
  );
  const [routes, SetRoutes] = useState([]);
  useEffect(() => {
    document.body.classList.remove("dark-theme");
    let __routes = getRoutes(token.organization);
    let _routes = [];
    let index = 0;
    for (const r1 of __routes) {
      if (r1.url) {
        _routes.push(
          <Route
            key={index++}
            path={r1.url}
            exact={r1.exact}
            component={layoutRender(r1.main)}
          />
        );
      }
      if (!r1.items) {
        continue;
      }
      for (const r2 of r1.items) {
        _routes.push(
          <Route
            key={index++}
            path={r2.url}
            exact={r2.exact}
            component={layoutRender(r2.main)}
          />
        );
        if (!r2.items) {
          continue;
        }
        for (const r3 of r2.items) {
          _routes.push(
            <Route
              key={index++}
              path={r3.url}
              exact={r3.exact}
              component={layoutRender(r3.main)}
            />
          );
        }
      }
    }

    SetRoutes(_routes);
  }, []);

  const layoutRender = (component) => (route) => {
    return <PanelLayout component={component} route={route} />;
  };

  return (
    <>
      <div className="h-full">
        <SockectProvider socket={socket}>
          <Switch>
            {/* <Route
              key={1}
              path={"/dashboard/pm/nmos2"}
              exact={true}
              component={layoutRender(nmos)}
            /> */}
            {routes}
            <Route component={NotFound} />
          </Switch>
        </SockectProvider>
      </div>
    </>
  );
}
